import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './imageListComponent.module.css';
import { LoaderComponent } from '../loader/LoaderComponent';

type ItemPropsType = {
  url: string,
  isActive?: boolean,
  load?: boolean,
  onClick: () => void,
};

type PropsType = {
  images: ItemPropsType[],
};

export const ImageListItemComponent: FC<ItemPropsType> = ({
  isActive, onClick, url, load
}) => (
    <div className={styles.itemContainer}>
        <div
            className={classNames(styles.image, { [styles.active]: isActive })}
            onClick={onClick}
            style={{
              ...(url ? { backgroundImage: `url(${url})` } : {})
            }}
        />
        {load && <LoaderComponent />}
    </div>
);

const ImageListComponent: FC<PropsType> = ({ images }) => (
    <div className={styles.container}>
        {images.map((props, index) => (
            <ImageListItemComponent key={index} {...props} />
        ))}
    </div>
);

export default ImageListComponent;
